import { EJRecoveryState } from "states/ej-recovery-state";
import { ClientController } from "../ClientController";

export class SocialRecoveryState extends EJRecoveryState {
    public onEnter(): void {
        ClientController.getInstance().notifyRecovery();
        super.onEnter();
    }
}